import { FeedbackRequestsEffects } from './feedback-requests.effects';

export const effects: Array<any> = [
  FeedbackRequestsEffects,
];

export * from './feedback-requests.effects';
